import React from 'react';
import PropTypes from 'prop-types';
import FormularioNuevoRNC from './FormularioNuevoRNC';

const TabNuevoRNC = ({ onSuccess, onCancel }) => {
    return (
        <FormularioNuevoRNC
            onSuccess={onSuccess}
            onCancel={onCancel}
        />
    );
};

TabNuevoRNC.propTypes = {
    onSuccess: PropTypes.func.isRequired,
    onCancel: PropTypes.func
};

export default TabNuevoRNC;
